import { getHeaders } from "./utils";
export async function obtenerUsuariosDispositivos() {
  try {
    const { code, body } = await fetch(
      `https://gestiondeflota.boltrack.net/rastreo-movil/api/usuario/obtener-usuarios-dispositivos`,
      {
        headers: getHeaders({ authenticate: true }),
        method: "GET",
      }
    ).then((res) => res.json());
    return { code, body };
  } catch (err) {
    console.log("login err");
    console.log(err);
    return [];
  }
}

export async function obtenerEmpresa() {
  try {
    const { code, body } = await fetch(
      `https://gestiondeflota.boltrack.net/rastreo-movil/api/usuario/empresa`,
      {
        headers: getHeaders({ authenticate: true }),
        method: "GET",
      }
    ).then((res) => res.json());
    return { code, body };
  } catch (err) {
    console.log("login err");
    console.log(err);
    return [];
  }
}
